/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DraggableModal from 'src/app/components/DraggableModal/DraggableModal';

import { getAgentName } from 'src/app/helpers/units.helper';
import { contentActions, mapActions, unitsActions } from 'src/app/redux/actions';

import { reduxRootTypes } from 'src/types';
import styles from './OverlappedUnits.module.scss';
import {
  OverlappedMarker,
  overlappedUnitsPopup,
  OverlappedUnitsPopupArgs,
  OverlappedUnitsPropTypes,
} from './overlapped-units.config';
import { debounce } from 'lodash';
import { SearchOutlined } from '@ant-design/icons';
import { UnitType } from 'src/types/unit.type';
import { InputRef } from 'antd/es/input/Input';
import Input from 'antd/es/input';
import Pagination from 'antd/es/pagination/Pagination';
import { preloadMilsymbol } from 'src/app/helpers/milSymbol.helper';

const pageSize = 14;

const OverlappedUnits: React.FC<OverlappedUnitsPropTypes> = ({ mapMarkerController }) => {
  const inputRef = useRef<InputRef>(null);
  const dispatch = useDispatch();

  const { activeTabs } = useSelector((state: reduxRootTypes.RootStateType) => state.mapState);

  const [contentEvent, setContentEvent] = useState<L.LeafletMouseEvent | undefined>(undefined);
  const [contentMarkers, setContentMarkers] = useState<OverlappedMarker[] | undefined>([]);
  const [orgContentMarkers, setOrgContentMarkers] = useState<OverlappedMarker[] | undefined>([]);

  const [currentPage, setCurrentPage] = useState(1);

  const [searchValue, setSearchValue] = useState<string | undefined>(undefined);

  // useEffect(() => {
  //   if (inputRef.current) {
  //     inputRef.current.focus();
  //   }
  // }, [inputRef.current]);

  const debouncedSearch = useRef(
    debounce(async (criteria) => {
      setSearchValue(criteria);
    }, 300),
  ).current;

  const onSearch = (input: string | React.ChangeEvent<HTMLInputElement>) => {
    if (typeof input === 'string') {
      debouncedSearch(input);
    } else {
      debouncedSearch(input.target.value);
    }
  };

  const overlappedUnitsCallback = (props: OverlappedUnitsPopupArgs) => {
    const modified = overlappedUnitsPopup(props);

    if (modified) {
      setContentEvent(modified.mouseEvent);
      setContentMarkers(modified.markers);
      setOrgContentMarkers(modified.markers);
    }
  };

  const reset = () => {
    setSearchValue(undefined);
    setContentEvent(undefined);
    setContentMarkers(undefined);
    setOrgContentMarkers(undefined);
  };

  useEffect(() => {
    if (searchValue && orgContentMarkers) {
      setContentMarkers(
        orgContentMarkers.filter(({ unit }) => getAgentName(unit)?.startsWith(searchValue.toUpperCase())),
      );
    } else {
      if (orgContentMarkers) {
        setContentMarkers(orgContentMarkers);
      }
    }
  }, [searchValue]);

  const onPressEscape = useCallback((event: KeyboardEvent) => {
    if (event.key === 'Escape') {
      reset();
    }
  }, []);

  useEffect(() => {
    document.addEventListener('keydown', onPressEscape);

    return () => {
      document.removeEventListener('keydown', onPressEscape);
    };
  }, []);

  useEffect(() => {
    const loadMilSymbol = async () => {
      await preloadMilsymbol();
    };

    loadMilSymbol();
  }, []);
  useEffect(() => {
    if (mapMarkerController) {
      mapMarkerController.setOverlappedUnitsPopup(overlappedUnitsCallback);
    }
  }, [mapMarkerController]);

  const onClickOverlappedUnit = (id: number, unitType: UnitType) => {
    dispatch(unitsActions.sitrepSelectUnit(id, unitType));
    dispatch(mapActions.setActiveTab({ key: 'sitrep', bool: true }));

    if (activeTabs.strategies) {
      dispatch(contentActions.setOverlappedEtmenId(id));
    }
  };

  const onRightClickOverlappedUnit = (e: React.MouseEvent<HTMLDivElement, MouseEvent>, id: number) => {
    e.preventDefault();
    if (contentMarkers && contentEvent) {
      const findedMarker = contentMarkers.find((o) => o.marker.options.unitId === id)?.marker;
      findedMarker?.fire('contextmenu', { ...contentEvent, unitId: id }, true);
      reset();
    }
  };

  return contentEvent && contentMarkers ? (
    <DraggableModal
      id="overlappedUnits"
      headerText=""
      className={styles.drag}
      contentClassName={styles.overlappedUnitsModalContent}
      onClickClose={() => {
        reset();
      }}
      position={contentEvent.containerPoint}
      isHeaderOn
    >
      <div className="overlapped-unit-search-input-container">
        <Input
          className="overlapped-unit-search-input"
          ref={inputRef}
          placeholder="Search by Agent Name"
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
          addonAfter={<SearchOutlined style={{ fontSize: '20px' }} />}
        />
      </div>

      <div className="overlapped-list popup-row grid-col-2-fixed">
        {contentMarkers
          .slice((currentPage - 1) * pageSize, currentPage * pageSize)
          .map(({ icon, unit, id, unitType }) => {
            const canvasSrc = (icon.options.html as HTMLCanvasElement).toDataURL();

            return (
              <div
                key={id}
                className={styles.overlappedUnitsModalContent__wrapper}
                onClick={() => onClickOverlappedUnit(id, unitType)}
                onContextMenu={(e) => onRightClickOverlappedUnit(e, id)}
              >
                <img src={canvasSrc} alt="" />
                <p>{getAgentName(unit)}</p>
              </div>
            );
          })}
      </div>

      {contentMarkers.length > pageSize && (
        <Pagination
          current={currentPage}
          onChange={(e) => setCurrentPage(e)}
          pageSize={pageSize}
          total={contentMarkers.length}
          showSizeChanger={false}
          size="small"
          style={{ textAlign: 'center', margin: '5px 0px' }}
        />
      )}
    </DraggableModal>
  ) : null;
};

export default OverlappedUnits;
function setSearchValue(criteria: any) {
  throw new Error('Function not implemented.');
}
